import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { articlesData } from '../../mocks/articles';
import SEO from '../../components/base/SEO';

export default function ArticleDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const article = articlesData.find(a => a.id === Number(id));

  if (!article) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-32 pb-20 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Makale Bulunamadı</h1>
            <button
              onClick={() => navigate('/makaleler')}
              className="px-6 py-3 bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Makalelere Dön
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const relatedArticles = articlesData.filter(a => a.id !== article.id && a.category === article.category).slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title={`${article.title} | Psikolog Esra Erten`}
        description={article.excerpt}
        keywords={`${article.category}, çocuk psikolojisi, ergen psikolojisi, ebeveynlik, psikoloji makalesi`}
        canonical={`https://psikologesraerten.com/makale/${article.id}`}
        ogImage={article.image}
      />
      <Navbar />

      <article className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate('/makaleler')}
            className="flex items-center text-teal-600 hover:text-teal-700 mb-8 cursor-pointer group"
          >
            <i className="ri-arrow-left-line text-xl mr-2 group-hover:-translate-x-1 transition-transform"></i>
            <span className="font-medium">Makalelere Dön</span>
          </button>

          <div className="mb-8">
            <span className="inline-block px-4 py-1.5 bg-teal-500 text-white text-sm font-medium rounded-full mb-4">
              {article.category}
            </span>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {article.title}
            </h1>
            <div className="flex items-center text-gray-500 mb-8">
              <span>{article.date}</span>
              <span className="mx-3">•</span>
              <span>{article.readTime}</span>
            </div>
          </div>

          <div className="w-full h-96 rounded-2xl overflow-hidden mb-12">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            {article.fullContent ? (
              <div 
                className="article-content text-gray-700 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: article.fullContent }}
              />
            ) : (
              <p className="text-gray-700 leading-relaxed text-lg">{article.excerpt}</p>
            )}
          </div>

          <div className="mt-16 pt-8 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <button className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  <i className="ri-heart-line text-2xl"></i>
                  <span className="text-sm font-medium">Beğen</span>
                </button>
                <button className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  <i className="ri-share-line text-2xl"></i>
                  <span className="text-sm font-medium">Paylaş</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>

      {relatedArticles.length > 0 && (
        <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-teal-50 to-blue-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">İlgili Makaleler</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {relatedArticles.map((relatedArticle) => (
                <div
                  key={relatedArticle.id}
                  onClick={() => navigate(`/makale/${relatedArticle.id}`)}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <div className="h-56 overflow-hidden">
                    <img
                      src={relatedArticle.image}
                      alt={relatedArticle.title}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <span className="inline-block px-3 py-1 bg-teal-500 text-white text-xs font-medium rounded-full mb-3">
                      {relatedArticle.category}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{relatedArticle.title}</h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">{relatedArticle.excerpt}</p>
                    <div className="flex items-center text-xs text-gray-400">
                      <span>{relatedArticle.date}</span>
                      <span className="mx-2">•</span>
                      <span>{relatedArticle.readTime}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <Footer />

      <style>{`
        .article-content h2 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #111827;
          margin-top: 2.5rem;
          margin-bottom: 1.5rem;
          line-height: 1.3;
        }

        .article-content p {
          margin-bottom: 1.5rem;
          line-height: 1.8;
          font-size: 1.125rem;
        }

        .article-content strong {
          font-weight: 600;
          color: #111827;
        }
      `}</style>
    </div>
  );
}
